import { LocalStorageService } from 'src/app/utils/LocalStorageService';
import { AfterViewInit, Component, DestroyRef, EventEmitter, Inject, OnInit, Output, ViewChild } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatDrawer, MatDrawerContainer } from '@angular/material/sidenav';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { JWTTokenServiceService } from 'src/app/public/services/token.service';
import { TimerService } from 'src/app/utils/timer.service';
import { TrackingService } from '../../services/tracking.service';
import { SubscriptionBillingLockService } from 'src/app/private/services/subscription-billing-lock.service';

const SERVICES: any[] = [TimerService];
@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  providers: [SERVICES],
  styleUrls: ['./main.component.scss'],


})
export class MainComponent implements OnInit, AfterViewInit {
  @ViewChild('drawer', { static: true }) public drawer!: MatDrawer;
  @ViewChild('drawerContainer') drawerContainer!: MatDrawerContainer;
  @Output("toggleMenu") toggleMenu: EventEmitter<any> = new EventEmitter();
  isSidebarCollapsed = false;
  isUserIdle: boolean = false;
  idleUserService = Inject(TimerService);
  clientId = 0;

  /** Original AMC-style banner (unchanged behaviour). */
  showBanner = false;
  bannerMessage =
    'Your Annual Maintenance Contract (AMC) for Tina is on 31 Mar 2025, Please initiate AMC payment by 1 April 2025 to enjoy uninterrupted services.';
  hideblockBanner = 'show';

  /** Shown under the header when subscription API returns critical reminders. No link for SUBSCRIPTION_EXPIRED (Reactivate) — user goes to Billing from the sidebar. */
  subscriptionAlert: { message: string; actionLabel?: string; actionUrl?: string } | null = null;

  /** Hide global strip on Billing & Subscription — that page shows its own subscription UI. */
  isBillingSubscriptionPage = false;

  private readonly billingSubscriptionPath = '/main/billing-subscription';

  private readonly bannerReminderTypes: string[] = [
    'NO_SUBSCRIPTION',
    'SUBSCRIPTION_EXPIRED',
    'GRACE_PERIOD',
    'TRIAL_EXPIRED',
    'PAYMENT_ISSUE'
  ];

  constructor(
    private jwt: JWTTokenServiceService,
    private tracker: TrackingService,
    private localStorageService: LocalStorageService,
    private subscriptionBillingLockService: SubscriptionBillingLockService,
    private router: Router,
    private destroyRef: DestroyRef
  ) {
    this.clientId = this.localStorageService.getClientId();
  }

  onSidebarCollapsedChange(collapsed: boolean): void {
    this.isSidebarCollapsed = collapsed;
    this.syncDrawerContentMargins();
  }

  ngAfterViewInit(): void {
    this.syncDrawerContentMargins();
  }

  private syncDrawerContentMargins(): void {
    setTimeout(() => this.drawerContainer?.updateContentMargins());
    setTimeout(() => this.drawerContainer?.updateContentMargins(), 250);
  }

  private loadSidebarCollapsedState(): void {
    try {
      const saved = localStorage.getItem('sidebar_collapsed');
      if (saved !== null) {
        this.isSidebarCollapsed = JSON.parse(saved) === true;
      }
    } catch {
      this.isSidebarCollapsed = false;
    }
  }

  ngOnInit() {
    this.loadSidebarCollapsedState();
    this.syncBillingSubscriptionRoute(this.router.url);
    this.router.events
      .pipe(
        filter((e): e is NavigationEnd => e instanceof NavigationEnd),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe((e) => this.syncBillingSubscriptionRoute(e.urlAfterRedirects));

    this.loadSubscriptionAlertBanner();
  }

  private syncBillingSubscriptionRoute(url: string): void {
    const u = (url || '').split('?')[0];
    this.isBillingSubscriptionPage =
      u === this.billingSubscriptionPath || u.startsWith(`${this.billingSubscriptionPath}/`);
  }

  private loadSubscriptionAlertBanner(): void {
    const clientId = this.localStorageService.getClientId();
    if (!clientId) {
      return;
    }
    this.subscriptionBillingLockService.ensureActivePackageForClient().subscribe({
      next: (res: any) => {
        const data = res?.data;
        const reminders = data?.reminders;
        if (!Array.isArray(reminders) || reminders.length === 0) {
          this.subscriptionAlert = null;
          return;
        }
        let picked: { type?: string; message?: string; action_label?: string; action_url?: string } | undefined;
        for (const t of this.bannerReminderTypes) {
          picked = reminders.find((r: { type: string }) => r.type === t);
          if (picked) {
            break;
          }
        }
        if (picked?.message) {
          const skipLink = picked.type === 'SUBSCRIPTION_EXPIRED';
          this.subscriptionAlert = {
            message: picked.message,
            actionLabel: skipLink ? undefined : picked.action_label,
            actionUrl: skipLink ? undefined : picked.action_url
          };
        } else {
          this.subscriptionAlert = null;
        }
      },
      error: () => {
        this.subscriptionAlert = null;
      }
    });
  }
}
